import { render } from "./BackToTopButton.vue?vue&type=template&id=eb15974a&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"

import "./BackToTopButton.vue?vue&type=style&index=0&id=eb15974a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb15974a"]])

export default __exports__